import { api } from "../../http";
import { store } from '../../store/store'

async function PutDataImagesLSP(rrim,dados) {
  try {
    
    const data = await api.put(`/rrim/spare-parts/${rrim}`, dados, {
      onUploadProgress: async (event) => {
        let progress = Math.round(
          (event.loaded * 100) / event.total
        );
      
     store.commit("SetLoadingPatternProgress", {
          status : true,
          progress :`A Lista de Spare Parts está ${progress}% carregada...`,
          total : (event.loaded / 1024 / 1024).toFixed(2), 
          loading : (event.total / 1024 / 1024).toFixed(2)
        }); // insere o loading

      },
    })
    .then((response) => {
      store.commit("SetLoadingPatternProgress", {
        status : false,
        progress : 0, 
        total : 0, 
        loading : 0,
      });  
    })
    .catch((err) => {
      store.commit("SetLoadingPatternProgress", {
        status : false,
        progress : 0, 
        total : 0, 
        loading : 0,
      });

      console.error(
        `Houve um problema ao realizar o upload da imagem no servidor `
      );
      
    

    });
 

    return data;


  } catch (e) {
    store.commit("SetLoadingPatternProgress", {
      status : false,
      progress : 0, 
      total : 0, 
      loading : 0,
    }); 
    
    console.log(e.message);
  }
}

export { PutDataImagesLSP };
